import React, { useState, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {
  Drawer as DrawerMUI,
  ListItemText,
  ListItem,
  List,
} from '@material-ui/core';
import { FontAwesomeIcon } from '@vr/lib';
import { openHelp } from '~/store/modules/help/actions';

const Drawer = styled(DrawerMUI)`
  .MuiDrawer-paper {
    width: 303px;
    background-color: ${({ theme }) => theme.colors.institucional};
    color: ${({ theme }) => theme.colors.white};
  }
  .MuiListItem-root {
    padding-left: 26px;
    height: 62px;
    border-bottom: 1px solid ${({ theme }) => theme.colors.negativoColor};
  }
  .MuiTypography-root {
    font-size: 0.9375rem;
    font-weight: 500;
  }
`;
const ButtonMenu = styled.button`
  color: ${({ theme }) => theme.colors.institucionalDark};
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  border-radius: 4px;
  width: 86px;
  height: 24px;
  background-color: ${({ theme }) => theme.colors.secondary};
  font-weight: 700;
  cursor: pointer;
`;
const BurgerIcon = styled(FontAwesomeIcon)`
  font-size: 0.9375rem;
  margin-right: 9px;
`;
const Header = styled.div`
  height: 126px;
  padding: 0 25px 0 26px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.colors.negativoColor};
`;
const Container = styled.div`
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  color: ${({ theme }) => theme.colors.white};
`;
const FirstName = styled.p`
  font-weight: 600;
  font-size: 1rem;
  margin-bottom: 14px;
  text-transform: capitalize;
`;
const Logout = styled.p`
  font-size: 0.9375rem;
  cursor: pointer;
  font-weight: 500;
`;
const ButtonText = styled.span`
  text-transform: uppercase;
  font-size: 0.75rem;
`;
const MenuItemIcon = styled(FontAwesomeIcon)`
  font-size: 1rem;
  color: ${({ theme }) => theme.colors.white};
  font-weight: 500;
  margin-right: 11px;
`;
const CloseIcon = styled(FontAwesomeIcon)`
  cursor: pointer;
  font-size: 1.3125rem;
  position: absolute;
  top: 0;
  right: 0;
`;

export default function Menu({ firstName, logout, onClick }) {
  const [isOpen, setIsOpen] = useState(false);
  const svas = useSelector(state => state.svas);
  const user = useSelector(state => state.user);
  const history = useHistory();
  const dispatch = useDispatch();

  const menuItems = useMemo(
    () => [
      {
        id: 1,
        name: 'user_edit',
        icon: 'user-edit',
        text: 'Alterar dados pessoais',
        class: 'userinfo-step',
        onClick() {
          history.push('/alterar-dados-pessoais');
        },
      },
      {
        id: 2,
        name: 'change_access_data',
        icon: 'key',
        text: 'Alterar dados de acesso',
        class: 'senhaacesso-step',
        onClick() {
          history.push('/alterar-dados-acesso');
        },
      },
      {
        id: 3,
        name: 'quick_search',
        icon: 'credit-card-blank',
        class: 'consultarapida-step',
        text: 'Consultar cartão provisório ',
        onClick() {
          onClick('quick_search');
        },
      },
      {
        id: 4,
        name: 'store_recommendation',
        icon: 'store',
        text: 'Indique um estabelecimento',
        class: 'indiqueec-step',
        onClick() {
          history.push('/indique');
        },
      },
      {
        id: 5,
        name: 'sva',
        icon: 'plus-circle',
        text: 'Serviços adicionais',
        class: 'servicosadicionais-step',
        onClick() {
          history.push('/servicos-adicionais');
        },
      },
      {
        id: 7,
        name: 'help',
        icon: 'question-circle',
        text: 'Ajuda',
        class: 'ajuda-step',
        onClick() {
          dispatch(openHelp());
        },
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [history, onClick],
  );

  const toggleDrawer = open => event => {
    if (
      event.type === 'keydown' &&
      (event.key === 'Tab' || event.key === 'Shift')
    ) {
      return;
    }

    setIsOpen(open);
  };

  function showMenuOption(name) {
    let show = true;

    // Hide SVA if there is no data OR if user hasn't validated any cards.
    if (name === 'sva' && (!svas?.length || user?.firstAccess)) {
      show = false;
    }

    return show;
  }

  const list = () => (
    <div
      role="presentation"
      onClick={toggleDrawer(false)}
      onKeyDown={toggleDrawer(false)}
    >
      <List>
        <Header>
          <Container>
            <FirstName>Olá, {firstName?.split(' ')[0]}</FirstName>
            <Logout onClick={() => logout()}>sair</Logout>
            <CloseIcon
              className="closemenu-button"
              onClick={toggleDrawer(false)}
              icon={['fas', 'times']}
            />
          </Container>
        </Header>
        {menuItems.map(item => {
          const { id, name, icon, text, onClick } = item;
          let listItem;

          if (showMenuOption(name)) {
            listItem = (
              <ListItem
                className={item.class}
                button
                key={id}
                onClick={() => onClick()}
              >
                <MenuItemIcon icon={icon} />
                <ListItemText primary={text} />
              </ListItem>
            );
          }

          return listItem;
        })}
      </List>
    </div>
  );

  return (
    <>
      <ButtonMenu className="menu-button" onClick={toggleDrawer(true)}>
        <BurgerIcon icon={['fas', 'bars']} />
        <ButtonText>menu</ButtonText>
      </ButtonMenu>
      <Drawer anchor="right" open={isOpen} onClose={toggleDrawer(false)}>
        {list()}
      </Drawer>
    </>
  );
}

Menu.propTypes = {
  firstName: PropTypes.string,
  logout: PropTypes.func,
  onClick: PropTypes.func,
};
